import React from 'react';
import { MessageCircle, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#F8F5F0] py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              {/* Custom Logo Circle */}
              <div className="w-12 h-12 bg-[#CFAE70] rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white text-2xl font-bold">B</span>
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-bold text-[#003847]">BOCADIA</span>
                <span className="text-xs font-medium text-[#CFAE70]">La pausa que tu día merece</span>
              </div>
            </div>
            <p className="text-gray-600 leading-relaxed">
              Instalamos máquinas inteligentes de snacks, bebidas y café que mejoran la experiencia dentro de tus espacios.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-[#003847] mb-4">Enlaces rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('hero').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-600 hover:text-[#CFAE70] transition-colors"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('solucion').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-600 hover:text-[#CFAE70] transition-colors"
                >
                  Solución
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('beneficios').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-600 hover:text-[#CFAE70] transition-colors"
                >
                  Beneficios
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('nosotros').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-600 hover:text-[#CFAE70] transition-colors"
                >
                  Nosotros
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold text-[#003847] mb-4">Contacto</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://api.whatsapp.com/send/?phone=51992098884&text=Hola+me+interesa+instalar+una+maquina+en+uno+de+mis+espacios&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-600 hover:text-[#CFAE70] transition-colors group"
                >
                  <MessageCircle className="w-5 h-5 group-hover:scale-110 transition-transform" />
                  <span>+51 992 098 884</span>
                </a>
              </li>
              <li>
                <a
                  href="https://api.whatsapp.com/send/?phone=51937468463&text=Buen+dia,+necesito+ayuda+con+un+incidente+en+la+maquina+ubicada+en+&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-600 hover:text-[#CFAE70] transition-colors group"
                >
                  <MessageCircle className="w-5 h-5 group-hover:scale-110 transition-transform" />
                  <span>+51 937 468 463 (Soporte)</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:soportebocadia@outlook.com"
                  className="flex items-center gap-3 text-gray-600 hover:text-[#CFAE70] transition-colors group"
                >
                  <Mail className="w-5 h-5 group-hover:scale-110 transition-transform" />
                  <span>soportebocadia@outlook.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-600">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                <span>Perú</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-bold text-[#003847] mb-4">Síguenos</h3>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/bocadiavending"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-[#003847] rounded-full flex items-center justify-center hover:bg-[#1877F2] transition-all duration-300 hover:scale-110 shadow-lg group"
                aria-label="Facebook"
              >
                <Facebook className="w-6 h-6 text-white" />
              </a>
              <a
                href="https://www.instagram.com/bocadiavending"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-[#003847] rounded-full flex items-center justify-center hover:bg-gradient-to-br hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF] transition-all duration-300 hover:scale-110 shadow-lg group"
                aria-label="Instagram"
              >
                <Instagram className="w-6 h-6 text-white" />
              </a>
              <a
                href="https://www.tiktok.com/@bocadiavending"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-[#003847] rounded-full flex items-center justify-center hover:bg-[#000000] transition-all duration-300 hover:scale-110 shadow-lg group"
                aria-label="TikTok"
              >
                <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
            <p className="text-sm text-gray-600 mt-4">
              Síguenos en nuestras redes para conocer más sobre BOCADIA
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-300">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm text-center md:text-left">
              © {new Date().getFullYear()} BOCADIA. Todos los derechos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <button className="text-gray-600 hover:text-[#CFAE70] transition-colors">
                Privacidad
              </button>
              <button className="text-gray-600 hover:text-[#CFAE70] transition-colors">
                Términos
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
